import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        border: '1px solid #ffce01',
        cursor: 'pointer',
        outline: 'none',
        padding: '5px 0',
        background: '#ffce01',
        borderRadius: '12px',
    },
    text: {
        color: '#24263e',
        fontSize: 14,
        fontWeight: 700,
    }
}))

const Button = ({title, onClick}) => {
    const classes = useStyles();

    return (
        <div className={classes.root} onClick={() => onClick()}>
            <span className={classes.text}>
                {title}
            </span>
        </div>
    )
}

export default Button;